<template>
	<div class="action-button-wrapper">
      <b-button size="sm" variant="link" class="site-action-btn" @click="emitAction('serverInfo')">
          <span class="icon-cont">
              <server-icon class="icon-default server-icon"></server-icon>
          </span>
          <span>server info</span>
      </b-button>
  </div>
</template>

<script>
import ServerIcon from '../../assets/server.svg';
export default {
  name: "viewsite",
  props: ["site"],
  components:{
  	ServerIcon
  },
  data() {
    return {
      serverURL: window.serverURL,
    };
  },
  methods:{
    emitAction(action) {
      this.$emit('action', { action: action, site: this.site });
    },
  }
};
</script>